import * as React from "react";
import { Image } from "react-bootstrap";
import "./MethodNumber.scss";
import PropTypes from "prop-types";

const MethodNumber = (props) => {
  const number = props.number;
  const backgroundClass = `method-desktop-number-background-${props.background}`;
  return (
    <div className={backgroundClass + " method-number-desktop-container"}>
      <Image src={number} />
    </div>
  );
};

MethodNumber.propTypes = {
  number: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
};

export default MethodNumber;
